module.exports = __webpack_public_path__ + "static/media/N0.82021e66.jpg";